import {getLength} from '../util/utils';

const initialState ={
    faq: [],
    faqLength: null,
    forum: null,
    updateForum: true,
    tokenList : [null],
    pageLength: null,
    thread: null,
    threadComments: null,
    postURL: null,
    error: null,
    token: null
    // deleteStatus: false,
};

// const per = 10;
const page_size = 5;

function supportReducer(state=initialState, action){
  switch (action.type){
    case "GET_FAQ_FULFILLED":{
      return Object.assign({}, state, {
        faq: action.payload.faq,
        faqLength: action.payload.length
      });
    }

    case "GET_THREADS_FULFILLED":{
      return Object.assign({}, state, {
        forum: action.payload.threads,
        // pageLength: (!state.pageLength?action.payload.threads.length:state.pageLength),
        pageLength: getLength(state, action.payload, page_size),
        tokenList:
        (state.tokenList.includes(action.payload.next_token)?
          state.tokenList:[...state.tokenList, action.payload.next_token]
        ),
        updateForum: false
      });
    }

// This method is ridiculous. It needs to be updated but not going to do it now
    case "UPDATE_PAGE_LENGTH":{

      let lastToken = [...state.tokenList].pop();

      return Object.assign({}, state,{
        pageLength:
        (lastToken===action.currentToken?
         state.pageLength+action.payload.threads.length:state.pageLength
        )
      })
    }

    case "POST_THREAD_FULFILLED":{
      return Object.assign({}, state, {
        postURL: '/forum/'+action.payload,
        updateForum: true
      })
    }

    case "GET_THREAD_DETAIL_FULFILLED":{
      return Object.assign({}, state, {
        thread: action.payload.thread,
        threadComments: action.payload.comments
      });
    }

    case "GET_THREAD_DETAIL_REJECTED":{
      return Object.assign({}, state, {
        error: action.payload
      })
    }

    case "GET_ONLY_THREAD_FULFILLED":{
      return Object.assign({}, state, {
        thread: action.payload.thread,
        editStatus: false
      })
    }

    case "EDIT_THREAD_FULFILLED":{
      return Object.assign({}, state, {
        editStatus: true
      })
    }

    case "EDIT_THREAD_REJECTED":{
      return Object.assign({}, state, {
        error: action.payload
      })
    }

    case "POST_COMMENT_FULFILLED":{
      return Object.assign({}, state, {
        updateForum: true
      })
    }

    case "DELETE_COMMENT_FULFILLED":{
      return Object.assign({}, state, {
        updateForum: true
      })
    }

    case "GET_COMMENTS_FULFILLED":{
      return Object.assign({}, state, {
        threadComments: action.payload,
      })
    }

    case "SET_TOKEN":{
      return Object.assign({}, state, {
        token: action.payload
      })
    }

    default:
      return state;
  }
}

export default supportReducer;



// WEBPACK FOOTER //
// ./src/reducers/SupportReducer.js